import { ApolloClient, gql, HttpLink, InMemoryCache } from '@apollo/client'
// @ts-ignore
import Env from '../gen/Env'

export const WARMUP_MIGRATION_FUNCTION = gql`
  mutation warmupMigrationFunction {
    warmupMigrationFunction
  }
`

// Unauthenticated client used to warm the migration function before loginRedirect.
// Kept separate so it doesn't interfere with the main authenticated Apollo client.
const warmupClient = new ApolloClient({
  link: new HttpLink({ uri: Env.api }),
  cache: new InMemoryCache(),
})

export function warmupMigrationFunction() {
  return warmupClient.mutate({ mutation: WARMUP_MIGRATION_FUNCTION }).catch(() => {})
}
